import { AuthzGuard } from "@p0security/frontend-core/react";
import { AppPaths } from "@p0security/shared/routes/constants";
import { Navigate, Route } from "react-router-dom";

import { Page } from "../App/Page";
import { AGENTIC_ROLES } from "../App/roles";
import { AgenticClientsProvider } from "./AgenticClientsContext";
import { AgenticGatewayGuard } from "./AgenticGatewayGuard";
import { AgenticPage } from "./AgenticPage";
import { EventLog } from "./EventLog/EventLog";
import { AgenticClients } from "./overview/AgenticClients";
import { AgenticServers } from "./overview/AgenticServers";
import { AgenticPaths } from "./paths";

export const AgenticRoutes = (
  <Route element={<AuthzGuard requirement={AGENTIC_ROLES} />}>
    <Route element={<AgenticGatewayGuard />}>
      <Route
        path={AppPaths.AgenticAccess}
        element={
          <Page title="Agentic Access">
            <AgenticClientsProvider>
              <AgenticPage />
            </AgenticClientsProvider>
          </Page>
        }
      >
        <Route
          index
          element={<Navigate to={AgenticPaths.EventLog} replace />}
        />
        <Route path={AgenticPaths.Clients} element={<AgenticClients />}>
          <Route path=":clientId" element={<></>} />
        </Route>
        <Route path={AgenticPaths.Servers} element={<AgenticServers />} />
        <Route path={AgenticPaths.EventLog} element={<EventLog />} />
      </Route>
    </Route>
  </Route>
);
